import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import { classNames } from "../../utils/classNames";
import AccountComboboxInput from "../Reusable/AccountComboboxInput";
import NumberField from "../Reusable/NumberField";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextField";
import ACCOUNTS from "../../constant/Accounts";

const AccountForm = (props: any) => {
  const {
    control,
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    watch,
    isactive,
    setIsActive,
  } = props;

  return (
    <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
      <TextField label="Ledger Name" control={control} name={"name"} />
      <AccountComboboxInput
        url={APIS.COA}
        queryKey={"ledger-group"}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"Ledger Group"}
        setValue={setValue}
        props={{
          level__in: "1,2",
          is_group: true,
        }}
        getValues={getValues}
        placeholder={"Search... "}
        clearErrors={clearErrors}
      />
      <div className={tw`flex  gap-x-4`}>
        <NumberField
          value={getValues("opening_balance")}
          register={register("opening_balance")}
          errors={errors?.opening_balance}
          label={"Opening Balance"}
          setValue={setValue}
          delimiter=","
          clearErrors={clearErrors}
        />
        <div className={tw`flex w-52 h-10  border mt-8 rounded-full`}>
          <button
            onClick={() => setIsActive("credit")}
            type="button"
            className={classNames(
              isactive === "credit" ? tw`bg-primary text-white px-4` : tw``,
              tw`focus:outline-none px-4 py-2 rounded-full`
            )}
          >
            Credit
          </button>
          <button
            onClick={() => setIsActive("debit")}
            type="button"
            className={classNames(
              isactive === "debit" ? tw`bg-primary text-white  px-4` : tw``,
              tw`focus:outline-none px-4 rounded-full  py-2`
            )}
          >
            Debit
          </button>
        </div>
      </div>
      {watch("parent") === ACCOUNTS.SUNDRY_CREDITORS ||
      watch("parent") === ACCOUNTS.SUNDRY_DEBTORS ? (
        <>
          <div className={tw`mt-2`}>
            <TextField label="Address " control={control} name={"address"} />
          </div>
          <PhoneNumberField
            control={control}
            label={"Contact No."}
            name={"contact_number"}
            errors={errors?.contact_number}
          />
          <div className={tw`mt-2`}>
            <TextField
              label="Alt Address"
              control={control}
              name={"alt_address"}
            />
          </div>
          <div className={tw`mt-2`}>
            <TextField label="VAT/PAN No." control={control} name={"vat_pan"} />
          </div>
        </>
      ) : null}
    </div>
  );
};

export default AccountForm;
